import { render, staticRenderFns } from "./AnswerMultipleWithMedia.vue?vue&type=template&id=15aea858&scoped=true"
import script from "./AnswerMultipleWithMedia.vue?vue&type=script&lang=ts"
export * from "./AnswerMultipleWithMedia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aea858",
  null
  
)

export default component.exports